<script setup>
import Hero from "@/sections/about/Hero.vue";
import SplitImage from "@/sections/about/SplitImage.vue";
import SplitText from "@/sections/about/SplitText.vue";
import Team from "@/sections/about/Team.vue";
</script>

<template>
	<Hero title="About us" />

	<SplitText
		:column_one="{
			paragraph:
				'At Ghost Vision, we create sunglasses built for movement and energy. Designed for athletes, fans, and anyone who thrives in the fast lane, our eyewear combines precision performance with bold style. Every pair is engineered to keep up with the pace of competition while making a statement that turns heads on and off the field.',
		}"
		:column_two="{
			title: 'Engineered for speed. Built for those who never stop moving.',
		}"
	/>

	<SplitImage
		:images="[
			'https://ghostvision.s3.amazonaws.com/images/about/about-1.jpg',
			'https://ghostvision.s3.amazonaws.com/images/about/about-2.jpg',
		]"
	/>

	<SplitText
		:column_one="{
			tag: 'Product story',
		}"
		:column_two="{
			paragraph:
				'Our products are more than sunglasses. They are built with impact-resistant frames and lenses that bring a unique twist to every look. Each design features custom graphics on the lenses that reflect the personality and pride of the sports world. Whether you are on the sidelines, in the stands, or out in the streets, Ghost Vision delivers eyewear that keeps you sharp and confident under any condition.',
		}"
	/>

	<!-- <Team title="Team" /> -->

	<SplitText
		:column_one="{
			tag: 'Our vision',
		}"
		:column_two="{
			title: 'Every pair tells a story of strength, pride, and performance.',
			paragraph:
				'Ghost Vision was created for those who live for competition and never settle for average. We believe eyewear should be more than functional. It should be an extension of identity, a sign of strength, and a connection to the culture of sport. Our mission is to deliver designs that inspire confidence and elevate the experience of every game, every moment, every day.',
		}"
	/>
</template>
